import { createContext } from 'react';
import { TApplicationActionDispatch } from './actions/TApplicationActionDispatch';

export const ApplicationDispatchContext = createContext<TApplicationActionDispatch>(() => {});
